import React from "react";
import { connect } from "react-redux";
import { useLocation, useParams, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { USER, EVENTS, PRODUCTS, PURCHASE } from "../../../constants";
import eventType from "../../../prop-types/eventType";
import {
  Template,
  Divider,
  ButtonContainer,
  Button,
  Section
} from "../../../commons/elements/index";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  // Map state to props
  productSummary: PropTypes.shape({
    id: PropTypes.number.isRequired,
    packageName: PropTypes.string.isRequired,
    totalPrice: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired
  }).isRequired
};

function ProductSummary(props) {
  const { types, productSummary } = props;
  const location = useLocation();
  const params = useParams();
  const history = useHistory();

  const eventProductsUrl = `/${params.shortName}/${EVENTS}/${params.eventId}/${PRODUCTS}`;

  return (
    <Template header="Product Summary" tabName={USER} types={types}>
      <form>
        <Divider />
        <Section title={productSummary.packageName}>
          {productSummary.currency === "CAD" ? (
            <div>{`Total: CA$${productSummary.totalPrice}`} </div>
          ) : (
            <div>{`Total: $${productSummary.totalPrice}`} </div>
          )}
        </Section>
        <Divider />
        <ButtonContainer>
          <Button
            label="Cancel"
            className="cancel-btn"
            onClick={() => {
              history.push(`${eventProductsUrl}${location.search}`);
            }}
          />
          <Button
            label="Next"
            onClick={() => {
              history.push(
                `${eventProductsUrl}/${productSummary.id}/${PURCHASE}${location.search}`
              );
            }}
          />
        </ButtonContainer>
      </form>
    </Template>
  );
}

ProductSummary.propTypes = propTypes;

const mapStateToProps = (state) => ({
  productSummary: {
    id: state.events.events.selectedProduct.id,
    packageName: state.events.events.selectedProduct.name,
    totalPrice: state.events.events.selectedProduct.cost / 100,
    currency: state.events.events.selectedProduct.currency
  }
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSummary);
